// Blog functionality
const initBlog = () => {
	const blogGrid = document.querySelector('.blog__cards');
	const showMoreBtn = document.querySelector('.js-more');
	const blogTags = document.querySelectorAll('.js-filter');

	if (!blogGrid || !showMoreBtn) return;

	let currentCategory = 'all';
	let currentPage = 2; // Починаємо з 2, бо перші 4 вже завантажені через PHP
	let isLoading = false;

	// Show more functionality
	showMoreBtn.addEventListener('click', function () {
		if (isLoading) return;

		isLoading = true;
		showMoreBtn.classList.add('is-loading');

		loadMorePosts();
	});

	// Category filtering
	blogTags.forEach(tag => {
		tag.addEventListener('click', function () {
			if (isLoading) return;

			// Update active state
			blogTags.forEach(t => t.classList.remove('item--active'));
			this.classList.add('item--active');

			// Reset pagination
			currentCategory = this.dataset.filter;
			currentPage = 1; // Починаємо з 1 для нової категорії

			// Clear grid and load first 4 posts of category
			blogGrid.innerHTML = '';
			loadCategoryPosts();
		});
	});

	function loadCategoryPosts() {
		const postsPerPage = 4; // Завжди завантажуємо 4 пости для всіх категорій
		loadPosts(postsPerPage, true);
	}

	function loadMorePosts() {
		const postsPerPage = 4; // Завжди завантажуємо по 4 пости
		loadPosts(postsPerPage, false);
	}

	function loadPosts(postsPerPage, isCategory = false) {
		// Create AJAX request
		const xhr = new XMLHttpRequest();
		xhr.open('POST', ajax_params.ajaxurl, true);
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4 && xhr.status === 200) {
				try {
					const response = JSON.parse(xhr.responseText);

					if (response.success && response.data) {

						// Тільки додаємо HTML якщо він не порожній
						if (response.data.data && response.data.data.trim() !== '') {
							blogGrid.insertAdjacentHTML('beforeend', response.data.data);
						}

						// Show/hide show more button based on hasMore
						if (response.data.hasMore === false) {
							showMoreBtn.style.display = 'none';
						} else {
							showMoreBtn.style.display = 'block';
						}
					} else {
						console.error('AJAX Error:', response);
					}
				} catch (e) {
					console.error('JSON Parse Error:', e);
				}

				isLoading = false;
				showMoreBtn.classList.remove('is-loading');

				// Для категорії встановлюємо currentPage на 2
				if (isCategory) {
					currentPage = 2;
				} else {
					// Для show more збільшуємо currentPage
					currentPage++;
				}
			}
		};

		// Prepare data
		const data = new URLSearchParams();
		data.append('action', 'load_blog_posts');
		data.append('category', currentCategory);
		data.append('page', currentPage);
		data.append('posts_per_page', postsPerPage);
		data.append('current_posts_count', blogGrid.children.length);

		xhr.send(data);
	}
}

export default initBlog;
